// extracted by mini-css-extract-plugin
export default {"resend":"Unverified_resend__Ss5Qr"};